var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-5 pt-md-9 pb-2 pb-md-5",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "domains"
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        size: "20"
                      }
                    },
                    [_vm._v("mdi-keyboard-backspace")]
                  ),
                  _vm._v(" Back to Domains ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-header",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "6",
                                md: "4"
                              }
                            },
                            [_vm._v(" View Domain Transfer Request ")]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right",
                              attrs: {
                                cols: "6",
                                md: "8"
                              }
                            },
                            [
                              _vm.canBeRestarted
                                ? _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mx-1",
                                      attrs: {
                                        right: ""
                                      },
                                      on: {
                                        click: _vm.openModalRestart
                                      }
                                    },
                                    [_vm._v("Restart")]
                                  )
                                : _vm._e(),
                              _vm.canBeCanceled
                                ? _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mx-1",
                                      attrs: {
                                        secondary: "",
                                        right: ""
                                      },
                                      on: {
                                        click: _vm.openModalCancel
                                      }
                                    },
                                    [_vm._v("Cancel")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "gg-card-text",
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.items,
                          "hide-default-footer": "",
                          loading: _vm.loading
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.status",
                            fn: function fn(_ref) {
                              var item = _ref.item
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mb-1",
                                    attrs: {
                                      small: "",
                                      color: _vm.statusColor(item.status)
                                    }
                                  },
                                  [_vm._v(" mdi-circle ")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("capitalize")(item.status)) +
                                    " "
                                )
                              ]
                            }
                          },
                          {
                            key: "item.price",
                            fn: function fn(_ref2) {
                              var item = _ref2.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(parseFloat(item.price).toFixed(2)) +
                                    " USD "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showPayOption
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "gg-card",
                    [
                      _c(
                        "gg-card-header",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [_vm._v(" Domain Transfer Payment ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "gg-card-text",
                        [
                          _vm.showTabs
                            ? [
                                _c(
                                  "v-tabs",
                                  {
                                    staticClass: "mb-0",
                                    attrs: {
                                      flat: "",
                                      "background-color": "transparent"
                                    },
                                    model: {
                                      value: _vm.tab,
                                      callback: function callback($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab"
                                    }
                                  },
                                  [
                                    _c("v-tabs-slider", {
                                      attrs: {
                                        color: "green"
                                      }
                                    }),
                                    _c(
                                      "v-tab",
                                      {
                                        key: "payment",
                                        attrs: {
                                          exact: ""
                                        }
                                      },
                                      [_vm._v(" Paid Transfer ")]
                                    ),
                                    _c(
                                      "v-tab",
                                      {
                                        key: "free"
                                      },
                                      [_vm._v(" Free Transfer ")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-tabs-items",
                                  {
                                    model: {
                                      value: _vm.tab,
                                      callback: function callback($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-tab-item",
                                      [
                                        _c("payment-gateway", {
                                          ref: "paymentGateway",
                                          attrs: {
                                            compact: ""
                                          },
                                          on: {
                                            gateway: _vm.listenGateway,
                                            card: _vm.listenCard,
                                            "card-switch": _vm.listenCardNew,
                                            close: _vm.closeModal
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function fn() {
                                                  return [
                                                    _vm._v(
                                                      "Domain Transfer Payment"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              },
                                              {
                                                key: "actions",
                                                fn: function fn() {
                                                  return [
                                                    _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "gg-btn",
                                                              {
                                                                staticClass:
                                                                  "mr-4 ml-2",
                                                                attrs: {
                                                                  secondary: ""
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.closeModal
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Cancel "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "gg-btn",
                                                              {
                                                                attrs: {
                                                                  primary: "",
                                                                  loading:
                                                                    _vm.payment_loading
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.makePayment
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Pay with a credit card "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1114191476
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-tab-item",
                                      [
                                        _c(
                                          "gg-card-text",
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " You have a free domain transfer available. Select a service to redeem your free transfer against. "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "6",
                                                      md: "6",
                                                      sm: "12"
                                                    }
                                                  },
                                                  [
                                                    _c("gg-select", {
                                                      attrs: {
                                                        dense: "",
                                                        outlined: "",
                                                        label:
                                                          "Select Service for Free Transfer:",
                                                        items:
                                                          _vm.freeMigrationServices,
                                                        "item-value": "id",
                                                        "hide-details": ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "selection",
                                                            fn: function fn(
                                                              _ref3
                                                            ) {
                                                              var item =
                                                                _ref3.item
                                                              return [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.groupname
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      item.domain
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            key: "item",
                                                            fn: function fn(
                                                              _ref4
                                                            ) {
                                                              var item =
                                                                _ref4.item
                                                              return [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.groupname
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      item.domain
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        2837972988
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.freeMigrationService,
                                                        callback: function callback(
                                                          $$v
                                                        ) {
                                                          _vm.freeMigrationService = $$v
                                                        },
                                                        expression:
                                                          "freeMigrationService"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pb-4 pr-4",
                                                    attrs: {
                                                      cols: "12"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "gg-btn",
                                                      {
                                                        attrs: {
                                                          primary: "",
                                                          disabled: !_vm.freeMigrationService,
                                                          loading:
                                                            _vm.payment_loading
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.makeFreeTransfer
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Redeem Free Transfer "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c("payment-gateway", {
                                  ref: "paymentGateway",
                                  attrs: {
                                    compact: ""
                                  },
                                  on: {
                                    gateway: _vm.listenGateway,
                                    card: _vm.listenCard,
                                    "card-switch": _vm.listenCardNew,
                                    close: _vm.closeModal
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function fn() {
                                          return [
                                            _vm._v("Domain Transfer Payment")
                                          ]
                                        },
                                        proxy: true
                                      },
                                      {
                                        key: "actions",
                                        fn: function fn() {
                                          return [
                                            _c(
                                              "gg-btn",
                                              {
                                                attrs: {
                                                  secondary: ""
                                                },
                                                on: {
                                                  click: _vm.closeModal
                                                }
                                              },
                                              [_vm._v(" Cancel ")]
                                            ),
                                            _c(
                                              "gg-btn",
                                              {
                                                attrs: {
                                                  primary: "",
                                                  loading: _vm.payment_loading
                                                },
                                                on: {
                                                  click: _vm.makePayment
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " Pay with a credit card "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2712503994
                                  )
                                })
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalRestart
        },
        on: {
          close: _vm.closeModalRestart
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Restart Transfer ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "You are about to restart the domain transfer attempt. Please make sure you have addressed the reason for the failure before restarting the transfer."
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "If you need to provide us with a new EPP code, you may enter it below."
                  )
                ]),
                _c(
                  "p",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12",
                          sm: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          attrs: {
                            "aria-label": "Epp Code",
                            name: "EppCode",
                            outlined: "",
                            placeholder: "Epp Code"
                          },
                          model: {
                            value: _vm.eppCode,
                            callback: function callback($$v) {
                              _vm.eppCode = $$v
                            },
                            expression: "eppCode"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("p", [_vm._v("Are you sure you want to proceed?")])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeModalRestart
                    }
                  },
                  [_vm._v(" No ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.modalProceedLoading
                    },
                    on: {
                      click: _vm.proceedRestartTransfer
                    }
                  },
                  [_vm._v(" Yes ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalCancel
        },
        on: {
          close: _vm.closeModalCancel
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Cancel Transfer ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "You are about to cancel this domain transfer request."
                  )
                ]),
                _c("p", [_vm._v("Are you sure you want to proceed?")])
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeModalCancel
                    }
                  },
                  [_vm._v(" No ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.modalProceedLoading
                    },
                    on: {
                      click: _vm.proceedCancelTransfer
                    }
                  },
                  [_vm._v(" Yes ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }